module.exports = __webpack_public_path__ + "img/6.1783f7fa.jpg";